
<template>
  <div id="Conduite">
    <div v-if="loading < 1">
      <LoaderCar width="600px" marginTop="0"/>
    </div>
    <div class="calendar" v-else>
      <div class="nav">
        <DropdownNav/>
      </div>
      
      <div id="fullCalendar" @click="ordreVueMobile" class="col-12" v-if="showFicheCours == false">
        <FullCalendar :options="calendarOptions" ref="fullCalendar"/>
      </div>


      <FicheCours v-if="showFicheCours == true" :idRdv="idRdv" @cancelFicheRdv="cancelFicheRdv"/>
    </div>


  </div>
</template>

<script>

import '@fullcalendar/core/vdom'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment';
import FicheCours from "@/components/Moniteur/Planning/FicheCours.vue";
import DropdownNav from "@/components/DropdownNav.vue";
import LoaderCar from "@/components/LoaderCar.vue";

//import axios from 'axios'

export default {
  name: 'Conduite',
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    FicheCours,
    DropdownNav,
    LoaderCar
  },

  data() {
    return {
      loading : 0,
      showFicheCours : false,
      nextBtnPress : false,
      todayBtnActive : false,
      typeMotifchoix: '',
      typeMotifchoixId: '',
      expanded: false,
      adresse: "",
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'timeGridDay',
        nowIndicator: true,
        eventResizableFromStart: true,
        firstDay: 1,
        allDaySlot: true,
        slotMinTime: "07:00:00",
        slotMaxTime: "21:00:00",
        height: "auto",
        locale: "fr",
        selectable: true,
        timeZone: "local",
        headerToolbar: {
          start: "prev,next today",
          center: "title",
          end: "timeGridWeek,timeGridDay",
        },
        buttonText: {
          today: "Aujourd'hui",
          prev: "<",
          next: ">"
        },

        customButtons:{
          hideSunday: {
            text: 'Dimanche',
            click: (e) => this.hideSundayMethod(e),
            background: "red"
          },
          prev: {
            // this overrides the prev button
            text: "PREV",
            click: () => {
              this.todayBtnActive = false;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.prev();

              let date = moment(calendarApi.getDate().toString()).format(
                "YYYY-MM-DDTHH:mm:ss"
              );
              if(this.dayWeekPlanning == false){
                this.getMoniteurChange(date, false);
              }else{
                this.getMoniteurChange(date, true);
              }

              let resultIndispo = this.calendarOptions.events.filter(
                (e) => e.type != "indispo"
              );
              this.calendarOptions.events = resultIndispo;
            },
          },
          next: {
            // this overrides the next button
            text: "NEXT",
            click: () => {
              this.todayBtnActive = false;
              this.nextBtnPress = true;
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.next();

              let date = moment(calendarApi.getDate().toString()).format(
                "YYYY-MM-DDTHH:mm:ss"
              );

              if(this.dayWeekPlanning == false){
                this.getMoniteurChange(date, false);
              }else{
                this.getMoniteurChange(date, true);
              }

              let resultIndispo = this.calendarOptions.events.filter(
                (e) => e.type != "indispo"
              );
              this.calendarOptions.events = resultIndispo;
            },
          },

          today: {
            // this overrides the next button
            text: "Aujourd'hui",
            click: () => {
              this.todayBtnActive = true;
              this.nextBtnPress = false;
              let calendarApi = this.$refs.fullCalendar.getApi();
              if(this.calendarOptions.events != null){
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if(this.dayWeekPlanning == false){
                  this.getMoniteurChange(moment(new Date()).format("YYYY-MM-DDT00:00:00"), false);
                }else{
                  this.getMoniteurChange(date, true);
                }
              }

              calendarApi.today();
            },
          },

          timeGridDay: {
            // this overrides the next button
            text: "day",
            click: () => {
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.changeView('timeGridDay');
              calendarApi.today();
              this.dayWeekPlanning = false;
              this.todayBtnActive = true;
              this.nextBtnPress = false;
              //Lthis.getMoniteurChange(moment(new Date()).format("YYYY-MM-DDT00:00:00"), false);
              if(this.calendarOptions.events != null){
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if(this.dayWeekPlanning == false){
                  this.getMoniteurChange(moment(new Date()).format("YYYY-MM-DDT00:00:00"), false);
                }else{
                  this.getMoniteurChange(date, true);
                }
              }
            },
          },

          timeGridWeek: {
            // this overrides the next button
            text: "week",
            click: () => {
              let calendarApi = this.$refs.fullCalendar.getApi();
              calendarApi.changeView('timeGridWeek');
              calendarApi.today();
              this.dayWeekPlanning = true;
              this.todayBtnActive = true;
              this.nextBtnPress = false;
              if(this.calendarOptions.events != null){
                this.calendarOptions.events = [];
                let today = new Date();
                let diff =
                  today.getDate() -
                  today.getDay() +
                  (today.getDay() === 0 ? -6 : 1);
                let monday = new Date(today.setDate(diff));
                let date = moment(monday).format("YYYY-MM-DDTHH:mm:ss");
                if(this.dayWeekPlanning == false){
                  this.getMoniteurChange(moment(new Date()).format("YYYY-MM-DDT00:00:00"), false);
                }else{
                  this.getMoniteurChange(date, true);
                }
              }
            },
          },


        },


        events: [],
        select: this.select,
        eventClick: this.clickEvent,
        editable: true,
        selectAllow: this.selectAllow,
        eventChange: this.putDispoEleve,
        eventDidMount: this.eventhover,
        datesSet: this.addAllDayMessage,
      },
      moniteur: [],
      typeMotif: [],
      motif: "",
      choixDateResa: false,
      idRdv: false,
      ideleve: false,
      rdvjIndispo: [],
      lajdinspo: [],
      dayWeekPlanning : false
    }

  },
  mounted() {
    this.getMoniteur()
    this.getTypeMotif()
  },
  methods: {

    addAllDayMessage() {

      this.$nextTick(() => {
        
        const allDayHeaders = document.querySelectorAll('td.fc-daygrid-day');
        let divAllDayMessage = document.querySelectorAll('div.all-day-message-boite');
        if(divAllDayMessage.length != 0){
          divAllDayMessage.remove();
        }

        // Cible le "All Day"
        allDayHeaders.forEach(a => {
            let dayBoite = null; 
            let dayColor = null; 
            let dateAllDay = new Date(a["attributes"]["data-date"]["value"]);

            this.moniteur.params.forEach(p => {
              let dateParams = new Date(p.start);
              if(p.title != "INDISPO"){
                if(dateParams.getDay() == dateAllDay.getDay()){
                  dayBoite = p.title;
                  dayColor = p.color;
                }
              }
            })

            if(dayBoite != null){
              const messageDiv = document.createElement('div');
              messageDiv.className = 'all-day-message-boite';
              messageDiv.innerText = dayBoite;
              messageDiv.style.color = dayColor;
              messageDiv.style.fontSize = '14px';
              messageDiv.style.fontWeight = 'bold';
              messageDiv.style.padding = '5px';
              a.appendChild(messageDiv);
            }
        })

      });
    },


    cancelFicheRdv(){
      this.showFicheCours = false;
    },

    eventhover(info) {
      const { event, el } = info;
      const props = event.extendedProps;

      // Tooltip natif
      el.title = event.title;

      // On ne touche pas aux events "background"
      if (event.display === "background") return;

      // Uniquement les types qu'on veut enrichir
      const enrichTypes = ["resa", "exam", "exam blanc"];
      if (!enrichTypes.includes(props.type)) return;

      // Récupère le conteneur principal généré par FullCalendar
      const inner = el.querySelector(".fc-event-main");
      if (!inner) return;

      // Vide le contenu par défaut
      inner.innerHTML = "";

      // ── Heure ──
      const timeEl = document.createElement("div");
      timeEl.className = "ev-time";
      timeEl.textContent = info.timeText;
      inner.appendChild(timeEl);

      // ── Titre (nom élève / label event) ──
      const titleEl = document.createElement("div");
      titleEl.className = "ev-title";
      titleEl.textContent = event.title;
      inner.appendChild(titleEl);

      // ── Lieu début (resa) ──
      if (props.lieuDeb) {
        const debEl = document.createElement("div");
        debEl.className = "ev-meta";
        debEl.textContent = "deb : " + props.lieuDeb;
        inner.appendChild(debEl);
        el.title = el.title + " | deb : " + props.lieuDeb;
      }

      // ── Lieu fin (resa) ──
      if (props.lieuFin) {
        const finEl = document.createElement("div");
        finEl.className = "ev-meta";
        finEl.textContent = "fin : " + props.lieuFin;
        inner.appendChild(finEl);
        el.title = el.title + " | fin : " + props.lieuFin;
      }

      // ── Lieu (exam / exam blanc) ──
      if (props.lieu) {
        const lieuEl = document.createElement("div");
        lieuEl.className = "ev-meta";
        lieuEl.textContent = props.lieu;
        inner.appendChild(lieuEl);
        el.title = el.title + " | lieu : " + props.lieu;
      }

      // ── Élèves (exam / exam blanc) ──
      if (props.eleves) {
        const elevesEl = document.createElement("div");
        elevesEl.className = "ev-meta";
        elevesEl.textContent = props.eleves;
        inner.appendChild(elevesEl);
        el.title = el.title + " | " + props.eleves;
      }

      // ── Moniteur (exam / exam blanc) ──
      if (props.mono) {
        const monoEl = document.createElement("div");
        monoEl.className = "ev-meta";
        monoEl.textContent = "Moniteur : " + props.mono;
        inner.appendChild(monoEl);
        el.title = el.title + " | mono : " + props.mono;
      }

      // ── Motif d'annulation ──
      if (props.motif && props.motif !== false) {
        const motifEl = document.createElement("div");
        motifEl.className = "ev-motif";
        motifEl.textContent = "✕ " + props.motif;
        inner.appendChild(motifEl);
        el.title = el.title + " | Motif : " + props.motif;
      }

      // ── Badge statut AAC si présent ──
      if (props.statutAac && props.statutAac !== "null") {
        const aacEl = document.createElement("span");
        aacEl.className = "ev-badge";
        aacEl.textContent = props.statutAac;
        inner.appendChild(aacEl);
      }
    },

    getTypeMotif() {
      window.api.get("/type_motifs", {
        headers: {
          "Authorization": "Bearer " + this.$store.state.token
        },
      }).then(response => {
        this.typeMotif = response.data["hydra:member"]
        this.loading++;
      }).catch(error => {
        console.log(error)
      })
    },


    clickEvent(e) {
      if (e["event"]["_def"]["extendedProps"]["type"] == "resa" && e["event"]["_def"]["extendedProps"]["motif"] == false) {
        if (e["event"]["_def"]["extendedProps"]["done"] == false) {
          this.choixDateResa = e;
          this.idRdv = e.event["_def"].publicId;
          this.ideleve = e.event["_def"]["extendedProps"]["ideleve"];
          this.showFicheCours = true;

        } else {
          let now = new Date();
          let startDate = new Date(Date.parse(e["event"]["_def"]["extendedProps"]["doneDate"]["date"]));
          let endDate = new Date(startDate.setDate(startDate.getDate() + 1))
          if (now < endDate) {
            this.choixDateResa = e;
            this.idRdv = e.event["_def"].publicId;
            this.ideleve = e.event["_def"]["extendedProps"]["ideleve"];
          }
        }

      }
    },

    getMoniteurChange(date, planningForm){
      window.api.post("/moniteur/"+this.$store.state.user.id+"/changeplan", {
          date : date,
          planningForm: planningForm
        },
          {
            headers: {
              "Authorization": "Bearer " + this.$store.state.token
            },
          }).then(response => {
            if (this.calendarOptions.events.length != 0) {
              let filterEvent = this.calendarOptions.events.filter(
                (e) => e.type != "resa"
              );
              this.calendarOptions.events = filterEvent;
            }

            if (this.calendarOptions.events.length != 0) {
              let filterEvent = this.calendarOptions.events.filter(
                (e) => e.type != "exam"
              );
              this.calendarOptions.events = filterEvent;
            }

            if (this.calendarOptions.events.length != 0) {
              let filterEvent = this.calendarOptions.events.filter(
                (e) => e.type != "exam blanc"
              );
              this.calendarOptions.events = filterEvent;
            }

            if (this.calendarOptions.events.length != 0) {
              let filterEvent = this.calendarOptions.events.filter(
                (e) => e.type != "boite"
              );
              this.calendarOptions.events = filterEvent;
            }

            if (this.calendarOptions.events.length != 0) {
              this.calendarOptions.events = this.calendarOptions.events.filter(
                (e) => e.type != "semainetype"
              );
            }

            this.moniteur = response.data.moniteur[0];
            this.moniteur.indispos.forEach(indispo => {
              this.calendarOptions.events.push({ id: indispo.id, start: indispo.start.date, end: indispo.end.date, title: "INDISPO", color: "grey", type: "Indispo" })
            })

            this.moniteur.rdv.forEach(app => {

              let statAac = "";

              if(app.statAac != "null"){
                statAac = app.statAac;
              }

              if (app.motif.type == "Mono Absent") {
                this.calendarOptions.events.push({ id: app.id, title: app.eleve, start: moment(app.start.date).format("YYYY-MM-DDTHH:mm:ss"), end: moment(app.end.date).format("YYYY-MM-DDTHH:mm:ss"), color: "grey", type: "resa", done: app.done, "editable": false, "motif": "Mono Absent", "heure" : app.heure, lieuDeb: app.lieuDeb.nom, lieuFin: app.lieuFin.nom, statutAac: statAac })
              } else if (app.motif.type == "Incident") {
                this.calendarOptions.events.push({ id: app.id, title: app.eleve, start: moment(app.start.date).format("YYYY-MM-DDTHH:mm:ss"), end: moment(app.end.date).format("YYYY-MM-DDTHH:mm:ss"), color: "yellow", textColor: "black", type: "resa", done: app.done, "editable": false, "motif": "Incident", "heure" : app.heure, lieuDeb: app.lieuDeb.nom, lieuFin: app.lieuFin.nom, statutAac: statAac })
              } else if (app.motif == "null") {
                if (app.done == true) {
                  this.calendarOptions.events.push({ id: app.id, title: app.eleve, start: moment(app.start.date).format("YYYY-MM-DDTHH:mm:ss"), end: moment(app.end.date).format("YYYY-MM-DDTHH:mm:ss"), color: "teal", type: "resa", done: app.done, "editable": false, "motif": false, ideleve: app.ideleve, doneDate: app.doneDate, "heure" : app.heure, lieuDeb: app.lieuDeb.nom, lieuFin: app.lieuFin.nom, statutAac: statAac })
                } else {

                  let color = "green";

                  if(app.boite == "BM"){
                    color = "#ED7742";
                  }

                  this.calendarOptions.events.push({ id: app.id, title: app.eleve, start: moment(app.start.date).format("YYYY-MM-DDTHH:mm:ss"), end: moment(app.end.date).format("YYYY-MM-DDTHH:mm:ss"), color: color, type: "resa", done: app.done, "editable": false, "motif": false, ideleve: app.ideleve, "heure" : app.heure, lieuDeb: app.lieuDeb.nom, lieuFin: app.lieuFin.nom, statutAac: statAac })
                }

              }
            })

            this.moniteur.exams.forEach((i) => {
              this.calendarOptions.events.push({
                id: i.id,
                title: "EXAM : " + i.boite,
                start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                color: "pink",
                type: "exam",
                resourceId: i.moniteur.idMoni,
                lieu: i.lieu.nom,
                eleves: i.elevesText,
                mono: i.moniteur.surnom,
              });
            });

            this.moniteur.examsblanc.forEach((i) => {
              this.calendarOptions.events.push({
                id: i.id,
                title: "EXAM BLANC : " + i.boite,
                start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                color: "orange",
                type: "exam blanc",
                resourceId: i.moniteur.idMoni,
                lieu: i.lieu.nom,
                eleves: i.elevesText,
                mono: i.moniteur.surnom,
              });
            });

            (this.moniteur.indispoSemaineType || []).forEach((i) => {
              this.calendarOptions.events.push({
                id: i.id,
                title: "INDISPO",
                start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
                color: "#F3F2F2",
                textColor: "#5F5F5F",
                type: "semainetype",
                motif: false,
              });
            });

            this.moniteur.params.forEach((i) => {
                let today = new Date(this.$refs.fullCalendar.getApi().getDate());
                let todayDay = today.getDay();
                let startDate = new Date(i.start);
                let endDate = new Date(i.end);
                let startDay = startDate.getDay();
                let endDay = endDate.getDay();
                let diffStart = today.getDate() - todayDay + (todayDay == 0 ? -6 : startDay); // permet de récupérer un jour précis de la semaine actuel en mettant l'id du jour (0 = dimanche 1 = lundi...)
                let diffEnd = today.getDate() - todayDay + (todayDay == 0 ? -6 : endDay); // permet de récupérer un jour précis de la semaine actuel en mettant l'id du jour (0 = dimanche 1 = lundi...)

                startDate = new Date(today.setDate(diffStart));
                endDate = new Date(today.setDate(diffEnd));

                if(startDay == 0){
                  startDate = startDate.setDate(startDate.getDate() + 1 * 7);
                  startDate = new Date(startDate);
                }

                if(endDay == 0){
                  endDate = endDate.setDate(endDate.getDate() + 1 * 7);
                  endDate = new Date(endDate);
                }

                let ddStart = String(startDate.getDate()).padStart(2, '0');
                let ddEnd = String(endDate.getDate()).padStart(2, '0');
                let mm = String(today.getMonth() + 1).padStart(2, '0');
                let yyyy = today.getFullYear();

                let start = yyyy + "-" + mm + "-" + ddStart + "T" + i.start.split("T")[1];
                let end = yyyy + "-" + mm + "-" + ddEnd + "T" + i.end.split("T")[1];

                if(i.title == "INDISPO"){
                  this.calendarOptions.events.push({
                    id: i.id,
                    title: "INDISPO",
                    start: moment(start).format("YYYY-MM-DDTHH:mm:ss"),
                    end: moment(end).format("YYYY-MM-DDTHH:mm:ss"),
                    color: "#494949FF",
                    type: "boite",
                    motif: false,
                  });
                }

              });

          }).catch(error => {
            console.log(error)
          })
    },

    getMoniteur() {
      window.api.get("/moniteur/" + this.$store.state.user.id,
        {
          headers: {
            "Authorization": "Bearer " + this.$store.state.token
          },
        }).then(response => {
          if (this.calendarOptions.events.length != 0) {
            let filterEvent = this.calendarOptions.events.filter(
              (e) => e.type != "resa"
            );
            this.calendarOptions.events = filterEvent;
          }

          if (this.calendarOptions.events.length != 0) {
            let filterEvent = this.calendarOptions.events.filter(
              (e) => e.type != "exam"
            );
            this.calendarOptions.events = filterEvent;
          }

          if (this.calendarOptions.events.length != 0) {
            let filterEvent = this.calendarOptions.events.filter(
              (e) => e.type != "exam blanc"
            );
            this.calendarOptions.events = filterEvent;
          }

          if (this.calendarOptions.events.length != 0) {
            this.calendarOptions.events = this.calendarOptions.events.filter(
              (e) => e.type != "semainetype"
            );
          }

          this.moniteur = response.data.moniteur[0];
          this.moniteur.indispos.forEach(indispo => {
            this.calendarOptions.events.push({ id: indispo.id, start: indispo.start.date, end: indispo.end.date, title: "INDISPO", color: "grey", type: "Indispo" })
          })

          this.moniteur.rdv.forEach(app => {

            let statAac = "";

            if(app.statAac != "null"){
              statAac = app.statAac;
            }

            if (app.motif.type == "Mono Absent") {
              this.calendarOptions.events.push({ id: app.id, title: app.eleve, start: moment(app.start.date).format("YYYY-MM-DDTHH:mm:ss"), end: moment(app.end.date).format("YYYY-MM-DDTHH:mm:ss"), color: "grey", type: "resa", done: app.done, "editable": false, "motif": "Mono Absent", "heure" : app.heure, lieuDeb: app.lieuDeb.nom, lieuFin: app.lieuFin.nom, statutAac: statAac })
            } else if (app.motif.type == "Incident") {
              this.calendarOptions.events.push({ id: app.id, title: app.eleve, start: moment(app.start.date).format("YYYY-MM-DDTHH:mm:ss"), end: moment(app.end.date).format("YYYY-MM-DDTHH:mm:ss"), color: "yellow", textColor: "black", type: "resa", done: app.done, "editable": false, "motif": "Incident", "heure" : app.heure, lieuDeb: app.lieuDeb.nom, lieuFin: app.lieuFin.nom, statutAac: statAac })
            } else if (app.motif == "null") {
              if (app.done == true) {
                this.calendarOptions.events.push({ id: app.id, title: app.eleve, start: moment(app.start.date).format("YYYY-MM-DDTHH:mm:ss"), end: moment(app.end.date).format("YYYY-MM-DDTHH:mm:ss"), color: "teal", type: "resa", done: app.done, "editable": false, "motif": false, ideleve: app.ideleve, doneDate: app.doneDate, "heure" : app.heure, lieuDeb: app.lieuDeb.nom, lieuFin: app.lieuFin.nom, statutAac: statAac })
              } else {

                let color = "green";

                if(app.boite == "BM"){
                  color = "#ED7742";
                }

                this.calendarOptions.events.push({ id: app.id, title: app.eleve, start: moment(app.start.date).format("YYYY-MM-DDTHH:mm:ss"), end: moment(app.end.date).format("YYYY-MM-DDTHH:mm:ss"), color: color, type: "resa", done: app.done, "editable": false, "motif": false, ideleve: app.ideleve, "heure" : app.heure, lieuDeb: app.lieuDeb.nom, lieuFin: app.lieuFin.nom, statutAac: statAac })
              }

            }
          })

        this.moniteur.exams.forEach((i) => {
          this.calendarOptions.events.push({
            id: i.id,
            title: "EXAM : " + i.boite,
            start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: "pink",
            type: "exam",
            resourceId: i.moniteur.idMoni,
            lieu: i.lieu.nom,
            eleves: i.elevesText,
            mono: i.moniteur.surnom,
          });
        });

        this.moniteur.examsblanc.forEach((i) => {
          this.calendarOptions.events.push({
            id: i.id,
            title: "EXAM BLANC : " + i.boite,
            start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: "orange",
            type: "exam blanc",
            resourceId: i.moniteur.idMoni,
            lieu: i.lieu.nom,
            eleves: i.elevesText,
            mono: i.moniteur.surnom,
          });
        });

        (this.moniteur.indispoSemaineType || []).forEach((i) => {
          this.calendarOptions.events.push({
            id: i.id,
            title: "INDISPO",
            start: moment(i.start.date).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(i.end.date).format("YYYY-MM-DDTHH:mm:ss"),
            color: "#F3F2F2",
            textColor: "#5F5F5F",
            type: "semainetype",
            motif: false,
          });
        });

          if (this.dayWeekPlanning == false){
            
            this.moniteur.params.forEach((i) => {

              let today = new Date();
              let todayDay = today.getDay();
              let startDate = new Date(i.start);
              let endDate = new Date(i.end);
              let startDay = startDate.getDay();
              let endDay = endDate.getDay();
              let diffStart = today.getDate() - todayDay + (todayDay == 0 ? -6 : startDay); // permet de récupérer un jour précis de la semaine actuel en mettant l'id du jour (0 = dimanche 1 = lundi...)
              let diffEnd = today.getDate() - todayDay + (todayDay == 0 ? -6 : endDay); // permet de récupérer un jour précis de la semaine actuel en mettant l'id du jour (0 = dimanche 1 = lundi...)

              startDate = new Date(today.setDate(diffStart));
              endDate = new Date(today.setDate(diffEnd));

              if(startDay == 0){
                startDate = startDate.setDate(startDate.getDate() + 1 * 7);
                startDate = new Date(startDate);
              }

              if(endDay == 0){
                endDate = endDate.setDate(endDate.getDate() + 1 * 7);
                endDate = new Date(endDate);
              }

              let ddStart = String(startDate.getDate()).padStart(2, '0');
              let ddEnd = String(endDate.getDate()).padStart(2, '0');
              let mm = String(today.getMonth() + 1).padStart(2, '0');
              let yyyy = today.getFullYear();

              let start = yyyy + "-" + mm + "-" + ddStart + "T" + i.start.split("T")[1];
              let end = yyyy + "-" + mm + "-" + ddEnd + "T" + i.end.split("T")[1];


              if(i.title == "INDISPO"){
                this.calendarOptions.events.push({
                  id: i.id,
                  title: "INDISPO",
                  start: moment(start).format("YYYY-MM-DDTHH:mm:ss"),
                  end: moment(end).format("YYYY-MM-DDTHH:mm:ss"),
                  color: "#494949FF",
                  type: "boite",
                  motif: false,
                });
              }
            });
          }

          this.loading++;

        }).catch(error => {
          console.log(error)
        })
    },

    select() {
    },

    selectAllow(select) {
      return moment().diff(select.start) <= 0;
    },
  },
}
</script>

<style scoped>

div.conduite{
  width: fit-content;
}

div#fullCalendar{
    width: 98%;
    margin: auto;
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    margin-top: 1rem;
}

/* Fond jaune pour le jour actuel */
:deep(.fc-day-today) {
  background-color: #fffde7 !important;
}

/* En-têtes des colonnes de jours */
:deep(.fc-col-header-cell) {
  padding: 8px 0;
  font-size: 13px;
}

:deep(.fc-col-header-cell-cushion) {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  color: #555;
  font-weight: 500;
  text-transform: capitalize;
}

/* Jour actuel : numéro en badge bleu */
:deep(.fc-day-today .fc-col-header-cell-cushion) {
  color: #1a73e8;
}

/* Style des événements */
:deep(.fc-event) {
  border-radius: 6px !important;
  border: none !important;
  border-left: 3px solid rgba(0,0,0,.15) !important;
  font-size: 11px !important;
  padding: 3px 6px !important;
  box-shadow: none !important;
  transition: transform .1s, box-shadow .1s !important;
  overflow: hidden !important;
  cursor: pointer !important;
}

:deep(.fc-event:hover) {
  transform: translateY(-1px) !important;
  box-shadow: 0 3px 10px rgba(0,0,0,.12) !important;
}

:deep(.fc-event-time) {
  font-size: 10px;
  display: block;
}

:deep(.ev-time) {
  font-size: 10px;
  font-weight: 700;
  opacity: 0.75;
  display: block;
  margin-bottom: 1px;
  letter-spacing: 0.02em;
}

:deep(.ev-title) {
  font-weight: 600;
  font-size: 12px;
  display: block;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.ev-meta) {
  font-size: 10.5px;
  opacity: 0.85;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.35;
}

:deep(.ev-badge) {
  display: inline-block;
  margin-top: 10px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 1px 5px;
  border-radius: 20px;
  text-align: center;
  background: rgba(255, 255, 255, 0.3);
}

:deep(.ev-motif) {
  font-size: 9px;
  font-style: italic;
  margin-top: 3px;
  opacity: 0.85;
}

:deep(.fc-event-main) {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Grille générale */
:deep(.fc-timegrid-slot) {
  height: 40px;
}

:deep(.fc-timegrid-slot-label) {
  font-size: 12px;
  color: #888;
}

/* Suppression de la bordure trop marquée */
:deep(.fc-scrollgrid) {
  border-color: #e0e0e0 !important;
}

:deep(.fc-scrollgrid td),
:deep(.fc-scrollgrid th) {
  border-color: #e0e0e0 !important;
}

/* Toolbar générale */
:deep(.fc-toolbar) {
  padding: 8px 12px;
}

/* Suppression du style par défaut des groupes de boutons */
:deep(.fc-button-group),
:deep(.fc-button) {
  box-shadow: none !important;
  outline: none !important;
}

/* Boutons navigation (< >) */
:deep(.fc-prev-button),
:deep(.fc-next-button) {
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 50% !important;
  color: #555 !important;
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

:deep(.fc-prev-button:hover),
:deep(.fc-next-button:hover) {
  background-color: #f1f3f4 !important;
}

/* Bouton Aujourd'hui */
:deep(.fc-today-button) {
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 20px !important;
  color: #555 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 4px 14px !important;
  text-transform: capitalize !important;
}

:deep(.fc-today-button:hover) {
  background-color: #f1f3f4 !important;
}

:deep(.fc-today-button:disabled) {
  opacity: 0.5 !important;
}

/* Boutons Semaine / Jour / Dimanche */
:deep(.fc-timeGridWeek-button),
:deep(.fc-timeGridDay-button),
:deep(.fc-hideSunday-button) {
  background-color: transparent !important;
  border: none !important;
  border-radius: 20px !important;
  color: #555 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 4px 14px !important;
}

:deep(.fc-timeGridWeek-button:hover),
:deep(.fc-timeGridDay-button:hover),
:deep(.fc-hideSunday-button:hover) {
  background-color: #f1f3f4 !important;
}

/* Bouton actif */
:deep(.fc-timeGridWeek-button.fc-button-active),
:deep(.fc-timeGridDay-button.fc-button-active),
:deep(.fc-hideSunday-button.fc-button-active) {
  background-color: #e8f0fe !important;
  border-color: #e8f0fe !important;
  color: #1a73e8 !important;
}

/* Container groupe de boutons droits */
:deep(.fc-toolbar-chunk:last-child) {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  padding: 2px 4px;
}




</style>